import React, { useState, useRef, useEffect } from 'react';
import './index.less';
import { getWechatAgreement } from '@/service/banner';

const AgreementModal = (props: any) => {
  const { visible, onClose, onAgree, agreementContent, type } = props;
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [CustomAgreement, setCustomAgreement] = useState(false);
  // 检测是否滚动到底部
  const checkScroll = () => {
    if (!contentRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
    const isBottom = scrollTop + clientHeight >= scrollHeight - 20; // 20px缓冲
    setHasScrolledToBottom(isBottom);
  };

  // 同意协议
  const handleAgree = () => {
    if (!isChecked) return;
    onAgree && onAgree();
    onClose && onClose();
  };

  // 点击蒙层关闭
  const handleOverlayClick = (e: any) => {
    if (e.target === e.currentTarget) {
      onClose && onClose();
    }
  };

  useEffect(() => {
    if (visible) {
      
      // 显示时重置状态
      setHasScrolledToBottom(false);
      setIsChecked(false);
      // 滚动到顶部
      if (contentRef.current) {
        contentRef.current.scrollTop = 0;
      }

      if (type === 'user') {
        getWechatAgreement(4).then(res => {
          setCustomAgreement(res.data?.agreementContent)
        })
      } else {
        getWechatAgreement(3).then(res => {
          setCustomAgreement(res.data?.agreementContent)
        })
      }
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="agreement-modal">
        <div className="modal-header">
          <h3>{type === 'user' ? '用户协议' : '隐私协议'}</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div 
          className="modal-content" 
          ref={contentRef}
          onScroll={checkScroll}
        >
            <div dangerouslySetInnerHTML={{ __html: CustomAgreement}}></div>
        </div>
        
        <div className="modal-footer">
          <div className="agreement-check">
            <input 
              type="checkbox" 
              id="agreeCheck"
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
              disabled={!hasScrolledToBottom}
            />
            <label htmlFor="agreeCheck">
              我已阅读并同意上述协议
            </label>
          </div>
          
          <button 
            className={`agree-btn ${isChecked ? 'active' : 'disabled'}`}
            disabled={!isChecked}
            onClick={handleAgree}
          >
            同意并继续
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgreementModal;